// Registro público del demo (alliance.api: routes/api/onboarding.php). Rutas sin
// token: la página nunca recibe ni guarda tokens, solo el canje de un solo uso
// con el que alliance.dev abre la sesión en el subdominio de la empresa.

const API_URL = process.env.VUE_APP_API_URL;
const TENANT_URL = process.env.VUE_APP_TENANT_URL;

export const URL_LOGIN = "https://login.alliance-cloud.com/passport/login";

// Los mismos de Onboarding::ALIAS_REGEX y Onboarding::ALIAS_RESERVADOS
export const ALIAS_REGEX = /^[a-z0-9][a-z0-9-]{1,28}[a-z0-9]$/;
export const ALIAS_RESERVADOS = [
  "www",
  "test",
  "api",
  "app",
  "admin",
  "staff",
  "mail",
  "smtp",
  "ftp",
  "demo",
  "soporte",
  "support",
  "blog",
  "status",
  "landing",
  "portal",
  "pagos"
];

const CLAVE_PENDIENTE = "alliance.registroDemo";

// Alias sugerido a partir del nombre de la empresa: minúsculas sin acentos,
// todo lo que no sea letra o número pasa a un solo guion, sin guiones en los bordes
export function sugerirAlias(nombre) {
  return (nombre || "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 30)
    .replace(/-+$/, "");
}

// URL del subdominio donde alliance.dev cambia el canje por la sesión
export function urlCanje(alias, canje) {
  const base = TENANT_URL.replace("TENANT", alias);
  return `${base}/passport/canjear?canje=${encodeURIComponent(canje)}`;
}

// status 0 = sin conexión. code solo viene en los errores de negocio
// ({ code, httpCode, message, params }); errors en la validación (422)
export class ErrorApi extends Error {
  constructor(status, cuerpo) {
    super(`Error ${status} del registro`);
    this.status = status;
    this.code = (cuerpo && cuerpo.code) || null;
    this.errors = (cuerpo && cuerpo.errors) || null;
  }
}

async function pedir(metodo, ruta, cuerpo) {
  const headers = { Accept: "application/json" };
  if (cuerpo) headers["Content-Type"] = "application/json";

  let respuesta;
  try {
    respuesta = await fetch(`${API_URL}/${ruta}`, {
      method: metodo,
      headers,
      body: cuerpo ? JSON.stringify(cuerpo) : undefined
    });
  } catch (e) {
    throw new ErrorApi(0, null);
  }

  let datos = null;
  try {
    datos = await respuesta.json();
  } catch (e) {
    datos = null;
  }

  if (!respuesta.ok) throw new ErrorApi(respuesta.status, datos);

  return datos ? datos.payload : null;
}

export function revisarAlias(alias, email, reemplaza) {
  const params = new URLSearchParams();
  if (email) params.set("email", email);
  if (reemplaza) params.set("reemplaza", reemplaza);
  const query = params.toString();

  return pedir(
    "GET",
    `onboarding/registro/alias/${encodeURIComponent(alias)}${query ? `?${query}` : ""}`
  );
}

export function registrar(datos) {
  return pedir("POST", "onboarding/registro", datos);
}

export function reenviarCodigo(uuid) {
  return pedir("POST", `onboarding/registro/${uuid}/reenviar`);
}

export function verificarCodigo(uuid, codigo) {
  return pedir("POST", `onboarding/registro/${uuid}/verificar`, { codigo });
}

// Registro esperando el código: { uuid, email, pais, reenviosRestantes, enviadoEn }.
// sessionStorage puede no estar disponible (modo privado, bloqueado): sin él,
// recargar solo pierde el paso 2
export function leerPendiente() {
  try {
    const texto = sessionStorage.getItem(CLAVE_PENDIENTE);
    return texto ? JSON.parse(texto) : null;
  } catch (e) {
    return null;
  }
}

export function guardarPendiente(pendiente) {
  try {
    sessionStorage.setItem(CLAVE_PENDIENTE, JSON.stringify(pendiente));
  } catch (e) {
    // Sin almacenamiento el registro sigue en memoria
  }
}

export function borrarPendiente() {
  try {
    sessionStorage.removeItem(CLAVE_PENDIENTE);
  } catch (e) {
    // Nada que borrar
  }
}
